import { render } from "./bidangTanamanPangan.vue?vue&type=template&id=65ce960a"
import script from "./bidangTanamanPangan.vue?vue&type=script&lang=js"
export * from "./bidangTanamanPangan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__